// ═══════════════════════════════════════════════════════════
// Separadores de emisión — qué no se enseña nunca
// ═══════════════════════════════════════════════════════════
//
// La emisora intercala cortinillas, anuncios y aperturas entre los temas. Son
// audio real y el servidor los devuelve como cualquier otra pista, pero no son
// música: enseñarlos en la cola o en el historial hace que la parrilla parezca
// llena de discos que nadie ha puesto.
//
// Se reconocen por el nombre del álbum, que la emisora usa como marca.
//
// ── Por qué esto existe como módulo ──
//
// La regla estaba escrita **dos veces y no decía lo mismo**:
//
//   · `useNowPlaying` tenía ocho álbumes y normalizaba a minúsculas.
//   · `useLastTenSongs` tenía tres y comparaba la cadena tal cual, así que un
//     «Shorts» con mayúscula se le colaba entero.
//
// Y la cola de Radio no filtraba nada, que es por donde salió «Alta Fidelidad ·
// Shorts» en pantalla. Una regla de producto repetida en tres sitios con tres
// comportamientos distintos no es una regla: es una coincidencia.
//
// Si aparece un separador nuevo, se añade **aquí** y lo heredan los tres.

const SEPARATOR_ALBUMS = new Set([
  "shorts",
  "off-general",
  "anuncios",
  "aperturas",
  "apertura",
  "opening",
  "openings",
  "presentaciones",
]);

export function normalizeAlbumName(albumName) {
  return String(albumName || "")
    .toLowerCase()
    .trim();
}

/** ¿Es este álbum una cortinilla y no música? */
export function isSeparatorAlbum(albumName) {
  return SEPARATOR_ALBUMS.has(normalizeAlbumName(albumName));
}

/**
 * ¿Hay que ocultar esta pista? Acepta las tres formas en que llega una pista
 * por el camino —la del historial, la de la cola y la ya normalizada— porque
 * cada endpoint del servidor la envuelve distinto y quien filtra no tiene por
 * qué saberlo.
 */
export function isSeparatorTrack(track) {
  if (!track) return false;
  const album = track.albumName ?? track.song?.album ?? track.album;
  return isSeparatorAlbum(album);
}
